import _ from 'lodash';
import { apiSearch, apiFetch, apiRemove } from '../utility';

const apiBase = 'loadingAssignment';

export const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			dispatch,
			callback,
		});
	};
};

export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const importLoadingNumbers = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.import`,
			params,
			dispatch,
			successMessage : `Loading numbers imported successfully. 
				Click continue to return to the loading number page.`,
			onSuccessRedirectTo : '/logistics/loadingAssignments/pooled',
			callback,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			successMessage : `Loading number updated successfully. 
				Click continue to return to the loading number page.`,
			onSuccessRedirectTo : '/logistics/loadingAssignments/pooled',
			callback,
		});
	};
};

export const remove = ({loadingAssignmentId, callback = _.noop}) => {
	return dispatch => {
		apiRemove({
			base : apiBase,
			id : loadingAssignmentId,
			dispatch,
			callback,
		});
	};
};


export const getStats = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.getStats`,
			params,
			dispatch,
			callback
		});
	};
};

